import { BaseApiService } from '../../../../services/base/BaseApiService';
import { DashboardMetricsDto } from '../types/dashboard.types';

const CACHE_KEY = 'whatsapp_dashboard_metrics';
const CACHE_DURATION_MS = 5 * 60 * 1000; // 5 minutos

interface CacheEntry {
  data: DashboardMetricsDto;
  timestamp: number;
}

class DashboardServiceClass extends BaseApiService {
  private cache: Map<string, CacheEntry> = new Map();

  async getDashboardMetrics(days: number = 7): Promise<DashboardMetricsDto> {
    const cacheKey = `${CACHE_KEY}_${days}`;
    
    // Verificar cache
    const cached = this.cache.get(cacheKey);
    if (cached && Date.now() - cached.timestamp < CACHE_DURATION_MS) {
      return cached.data;
    }

    try {
      const response = await this.api.get<DashboardMetricsDto>(
        `/v1/whatsapp/dashboard?days=${days}`
      );

      // Armazenar em cache
      this.cache.set(cacheKey, {
        data: response.data,
        timestamp: Date.now()
      });

      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard metrics:', error);
      throw error;
    }
  }

  clearCache(): void {
    this.cache.clear();
  }

  clearCacheEntry(days: number): void {
    this.cache.delete(`${CACHE_KEY}_${days}`);
  }
}

export const DashboardService = new DashboardServiceClass();
export default DashboardService;
